const aLoadingPrimary = {
  aLoadingPrimary: {
    message: 'Cargando Datos...'
  }
}

export default aLoadingPrimary
